import { DSDropdown } from "@components/design-system/molecules";

import { REFERRAL_SOURCE_OPTIONS } from "../constants";
import StepWrapper from "../StepWrapper";

export const ReferralSourceStep = ({
  setReferralSource,
  referralSource,
}) => (
  <>
    <StepWrapper
      title="How did you hear about Scribenote?"
      description="This helps us know how to reach more vets like you, who are ready to save time on documentation."
      withBackground={false}
      maxWidth="max-w-[90vw] md:max-w-[40vw]"
    >
      <DSDropdown
        dataTestId="referral-source-dropdown"
        options={REFERRAL_SOURCE_OPTIONS}
        value={referralSource}
        onChange={(value) => {
          setReferralSource(value);
        }}
        width="w-full"
        placeholder="Select an option"
        getOptionTestId={(option) =>
          `referral-source-option-${option.value}`
        }
      />
    </StepWrapper>
  </>
);

export default ReferralSourceStep;
